import PropTypes from 'prop-types'

import defaultProps from '@/components/Form/defaultProps'
import propTypes from '@/components/Form/propTypes'
import { Info } from '@/components/Icons'
import TooltipTrigger from '@/components/Tooltip/TooltipTrigger'
import cn from '@/utilities/cn'

const Label = ({ children, className, tooltip }: any) => {
  return (
    <div className={cn('keyvalues__label', className)}>
      {children}
      {!!tooltip && (
        <TooltipTrigger overlay={tooltip}>
          <span className="label__tooltip">
            <Info />
          </span>
        </TooltipTrigger>
      )}
    </div>
  )
}

Label.displayName = 'KeyValueLabel'

Label.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  className: PropTypes.string,
  tooltip: propTypes.tooltip
}

Label.defaultProps = {
  children: null,
  className: '',
  tooltip: defaultProps.tooltip
}
export default Label
